/*
 * Copyright (c) 2020.
 * Project: Source
 * LastModified: 2/14/20, 3:23 PM
 * Author: diengv < Giáp Văn Điện >
 * Email: diengv@ominext.com
 * File name: enum.js
 * File path: D:/Projects/PMS/Source/Client/vuejs/src/app/enum.js
 */

export const DATA_PAGINATE = [30, 50, 80, 100, 150, 200, 250, 400, 500, 1000]
